import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {RunOutputSamplesTable} from 'lab-automation/output-samples/RunOutputSamplesTableConstants';
import RunOutputSamplesTableView from 'lab-automation/output-samples/RunOutputSamplesView';
import ResultsTableView from 'lab-automation/results-table/ResultsTableView';
import {ResultsTable} from 'notebook/integrations/results/ResultsTableConstants';
import {EditorPropertiesContext} from 'notebook/notes/core-ui/NoteContext';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';

interface NLADStructuredTableContainerProps {
  getIdFromCid: (cid: string) => string | number | undefined;
  versionedStructuredTable: RunOutputSamplesTable | ResultsTable;
  automationOutputFileArchiveRecord?: ArchiveRecord | null;
  viewer?: boolean;
}

/**
 * Renders a structured table for a NoteLinkedAssayData
 */

export default function NLADStructuredTableContainer(props: NLADStructuredTableContainerProps): JSX.Element {
  const editorPropertiesContextValue = useMemo(
    () => ({
      fileId: props.versionedStructuredTable.fileId,
      showFormulas: false,
      isConfig: props.versionedStructuredTable.isConfig,
    }),
    [props.versionedStructuredTable.fileId, props.versionedStructuredTable.isConfig]
  );

  return (
    <EditorPropertiesContext.Provider value={editorPropertiesContextValue}>
      <div className={css(styles.structuredTableView)}>
        {props.versionedStructuredTable.kind === StructuredTableKind.RESULTS ? (
          <ResultsTableView
            resultsTable={props.versionedStructuredTable}
            getIdFromCid={props.getIdFromCid}
            key={props.versionedStructuredTable.provenanceUuid}
            automationOutputFileArchiveRecord={props.automationOutputFileArchiveRecord}
            viewer={props.viewer}
          />
        ) : (
          <RunOutputSamplesTableView
            outputSamplesTable={props.versionedStructuredTable}
            getIdFromCid={props.getIdFromCid}
            key={props.versionedStructuredTable.provenanceUuid}
            viewer={props.viewer}
          />
        )}
      </div>
    </EditorPropertiesContext.Provider>
  );
}

const styles = StyleSheet.create({
  structuredTableView: {
    marginRight: '16px',
  },
});
